/**
 * En-tête profil (avatar, nom, poste) — colonne projets / Schedule. Non cliquable.
 */
import React, { useContext, useMemo, useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext.jsx';
import { AppContext } from '../../../contexts/AppContext';
import { assets } from '../../../assets/assets';
import { getPhotoUrl } from '../../../utils/imageUtils';

export default function WebProfileHeader() {
  const { user } = useAuth();
  const { userData } = useContext(AppContext);
  const [avatarFailed, setAvatarFailed] = useState(false);

  const displayName = userData?.nom_complet || userData?.name || user?.nom_complet || 'Employé';
  const poste = userData?.poste || userData?.roleName || user?.role?.nom || 'Employé';
  const profileSrc = useMemo(() => {
    const raw = userData?.profileImageUrl || userData?.photo || user?.profileImageUrl || null;
    if (!raw || avatarFailed) return null;
    return getPhotoUrl(raw);
  }, [userData?.profileImageUrl, userData?.photo, user?.profileImageUrl, avatarFailed]);

  return (
    <div className="flex items-center gap-3 px-4 py-3 bg-white border-b border-gray-200 shrink-0">
      <div className="h-14 w-14 shrink-0 overflow-hidden" title={displayName}>
        <img
          src={profileSrc || assets.employes}
          alt=""
          className={`h-full w-full ${profileSrc ? 'object-cover rounded-full' : 'object-contain'}`}
          onError={() => setAvatarFailed(true)}
        />
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-bold text-[#0B3A4A]">{displayName}</p>
        <p className="truncate text-xs text-gray-500">{poste}</p>
      </div>
    </div>
  );
}
